<div [formGroup]="parentForm">
  <div [formGroupName]="authControlKey">
    <div fxLayout="row wrap" fxLayoutGap="20px grid">
      <div fxFlex="100">
        <mat-card class="u-margin-bottom-15">
          <mat-card-header>
            <mat-card-title
              >{{
              "organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.authentication_details"
              | translate }}</mat-card-title
            >
          </mat-card-header>
          <mat-card-content>
            <div fxLayout="row wrap" fxLayoutGap="20px grid">
              <div fxFlex="50">
                <mat-form-field id="matFrmFieldProvider" style="width: 100%;">
                  <mat-label *ngIf="isProviderMagento2"
                    >{{ 'magento.interface_version' | translate }}</mat-label
                  >
                  <mat-label *ngIf="!isProviderMagento2"
                    >{{ 'magento.version' | translate }}</mat-label
                  >
                  <mat-select
                    id="matebasketInventoryOrderMagentoVersion"
                    formControlName="ebasketInventoryOrderMagentoVersion"
                  >
                    <mat-option value="v1">Version 1.0</mat-option>
                    <mat-option value="v2" *ngIf="enableMagento2 && !isProviderMagento2"
                      >Version 2.0</mat-option
                    >
                  </mat-select>
                </mat-form-field>
              </div>
              <div fxFlex="50">
                <mat-form-field class="mat-block" *ngIf="!isProviderMagento2">
                  <input
                    formControlName="ebasketInventoryMagentoUsername"
                    id="ebasketInventoryMagentoUsername"
                    matInput
                    [placeholder]="
                    'magento.username' |
                    translate"
                  />
                </mat-form-field>
              </div>
              <div fxFlex="50">
                <mat-form-field class="mat-block">
                  <input
                    formControlName="ebasketInventoryMagentoApiKey"
                    id="ebasketInventoryMagentoApiKey"
                    matInput
                    [placeholder]="
                    'magento.apiKey' |
                    translate"
                  />
                </mat-form-field>
              </div>

              <!-- <div
                fxFlex="50"
                *ngIf="parentForm.get(authControlKey).get('ebasketInventoryOrderMagentoVersion').value == 'v1' && !inventory && !webReturns"
              >
                <mat-form-field class="mat-block">
                  <input
                    formControlName="ebasketInventoryMagentoUrl"
                    id="ebasketInventoryMagentoUrl"
                    matInput
                    [placeholder]="
                      'magento.url' |
                      translate"
                  />
                </mat-form-field>
              </div> -->
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
    <div
      fxLayout="row wrap"
      fxLayoutGap="20px grid"
      *ngIf="parentForm.get(authControlKey).get('ebasketInventoryOrderMagentoVersion').value != 'v1' ||
      parentForm.get(authControlKey).get('ebasketInventoryOrderMagentoVersion').value != 'v2'
      || inventory || webReturns"
    >
      <div fxFlex="100">
        <mat-card class="u-margin-bottom-15">
          <mat-card-header>
            <div fxFlex="20" class="u-text-left">
              <mat-card-title>{{ "magento.api_details" | translate }}</mat-card-title>
            </div>
            <div fxFlex="80" class="u-text-right">
              <button
                [disabled]="action=='view' || isEBasketInventoryAddDisabled"
                mat-flat-button
                color="primary"
                (click)="openEbasketInventorySelectApiPopup();"
              >
                {{ 'magento.add' | translate}}
              </button>
            </div>
          </mat-card-header>
          <mat-card-content
            *ngFor="let apiDetails of parentForm.get(authControlKey).get('ebasketInventoryApiDetails')['controls']; let i = index"
            formArrayName="ebasketInventoryApiDetails"
          >
            <div [formGroupName]="i">
              <div fxFlex="80">
                <mat-accordion>
                  <mat-expansion-panel>
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        {{ apiDetails.value.selectedApi}}
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div fxLayout="row wrap" fxLayoutGap="20px grid">
                      <div fxFlex="50">
                        <mat-form-field class="mat-block">
                          <input
                            id="ebasketURL"
                            [required]="isRequired('url')"
                            formControlName="url"
                            matInput
                            [placeholder]="
                    'magento.url' |
                    translate"
                          />
                        </mat-form-field>
                      </div>
                      <div fxFlex="50">
                        <mat-form-field class="mat-block">
                          <mat-select
                            id="ebasketMethod"
                            formControlName="method"
                            [placeholder]="
                      'magento.select_method' |
                      translate"
                          >
                            <mat-option
                              *ngFor="let methods of method_types"
                              [value]="methods.value"
                            >
                              {{methods.name}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                  </mat-expansion-panel>
                </mat-accordion>
              </div>
              <div fxFlex="20" class="u-text-right">
                <button
                  [disabled]="action=='view'"
                  mat-flat-button
                  color="primary"
                  (click)="deleteEbasketInventoryApiDetailContainer(i);"
                >
                  {{ 'magento.delete' | translate}}
                </button>
              </div>
            </div>
          </mat-card-content>
          <div
            *ngFor="let apiDetails of parentForm.get(authControlKey).get('ebasketInventoryApiDetails')['controls']; let i = index"
          >
            <mat-error
              *ngIf="(action !== 'view') && (!apiDetails.value.url || !apiDetails.value.method)"
            >
              {{"organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.api_and_authentication_details_required"
              | translate }}
            </mat-error>
          </div>
        </mat-card>
      </div>
      <!-- <mat-error *ngIf="!parentForm.valid || !isEBasketInventoryAddDisabled">
        {{
        "organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.api_and_authentication_details_required"
        | translate }}
      </mat-error> -->
    </div>
  </div>
</div>
